'use client';
import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { styled } from '@mui/material/styles';
import MaterialFormLabel from '@mui/material/FormLabel';
const StyledFormLabel = styled(MaterialFormLabel)(({ theme }) => ({
    color: theme.palette.grey[900],
    '&.Mui-focused': {
        color: theme.palette.text.primary
    },
    marginBottom: theme.spacing(1),
    fontWeight: theme.typography.button.fontWeight,
    fontSize: theme.typography.button.fontSize
}));
export const FormLabel = React.forwardRef((props, ref) => (_jsx(StyledFormLabel, { ref: ref, ...props })));
FormLabel.displayName = 'FormLabel';
